import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { AiOutlineArrowLeft, AiFillCheckCircle } from "react-icons/ai";
import { BsChevronCompactRight } from "react-icons/bs";
import GrayButton from "../../../components/GrayButton";
import GreenButton from "../../../components/GreenButton";
import ConfirmReleaseModal from "../../../components/ConfirmReleaseModal";
import ReleaseModal from "../../../components/ReleaseModal";
import DisputeConfirmModal from "../../../components/DisputeConfirmModal";
import { PAYMENT_OFFER_VALUES } from "../../../constants/offers";

const ReleaseContainer = (props) => {
    const {isLoading, orderData, releaseToken } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showReleaseModal, setShowReleaseModal] = useState(false);
    const [showDisputeConfirm, setShowDisputeConfirm] = useState(false);
    const location = useLocation().pathname;
    const offerAccount = location.substring(location.lastIndexOf('/') + 1);

    const handlePayment = async () => {
        const result = releaseToken(offerAccount);
        if (result.result) {
            setShowConfirmModal(false);
            setShowReleaseModal(true);
        }
    }

    const handleDisputeConfirm = () => {
        setShowDisputeConfirm(false);
    }

    const handleRelease = () => {
        navigate("/orders");
    }

    return (
        <>
            <div className="flex flex-col mb-10">
                <div className="flex justify-between">
                    <a href="/orders" className="text-2xl flex items-center mb-2"><AiOutlineArrowLeft className="mr-4"/>{t("Sell")} {orderData.tokenName.toUpperCase()}</a>
                    <div className="p-2 rounded-lg bg-first-theme green-font flex items-center"><AiFillCheckCircle className="mr-2" />{t("Paid")}</div>
                </div>
                <div className="flex justify-between">
                    <div className="text-sm text-second-theme">{t("Wait for buyer confirmation")}</div>
                    <div className="text-sm text-second-theme"></div>
                </div>
            </div>
            <div className="flex items-center mb-8 md:mb-16 text-second-theme bg-first-theme rounded-tr-lg rounded-tl-lg">
                <div className="flex-1 border-b-2 border-gray-500 py-2">{t("Waiting for payment")}</div>
                <BsChevronCompactRight size={24} />
                <div className="flex-1 border-b-2 green-border py-2 text-white">{t("Release crypto")}</div>
                <BsChevronCompactRight size={24} />
                <div className="flex-1 border-b-2 border-gray-500 py-2">{t("Completed")}</div>
            </div>
            <div className="mb-8">
                <div className="text-left mb-4 md:mb-8">{t("Trade Information")}</div>
                <div className="flex flex-wrap justify-between text-left py-4 md:py-8 border-t-2 border-b-2 border-first-theme mb-8">
                    <div className="mb-2 mr-2">
                        <div className="text-sm text-second-theme">{t("Amount to receive")}</div>
                        <div className="">{orderData.fiatAmount.toLocaleString("en-US")}</div>
                    </div>
                    <div className="mb-2 mr-2">
                        <div className="text-sm text-second-theme">{t("Rate")}</div>
                        <div className="">{orderData.rate.toLocaleString("en-US")} {orderData.fiat.toUpperCase()}</div>
                    </div>
                    <div className="mb-2 mr-2">
                        <div className="text-sm text-second-theme">{t("Transaction fee %")}</div>
                        <div className="">{orderData.fee}%</div>
                    </div>
                    <div className="mb-2 mr-2">
                        <div className="text-sm text-second-theme">{t("Transaction fee amount")}</div>
                        <div className="">{orderData.moneyFee} {orderData.tokenName.toUpperCase()}</div>
                    </div>
                    <div className="mb-2 mr-2">
                        <div className="text-sm text-second-theme">{t("Crypto to send")}</div>
                        <div className="">{orderData.sellAmount.toLocaleString("en-US")} {orderData.tokenName.toUpperCase()}</div>
                    </div>
                </div>
            </div>
            <div className="text-left">
                <div className="mb-2">{t("Your Payment Information")}</div>
                <div className="text-sm text-second-theme mb-4">{t("This is your selected payment method")}</div>
                <div className="p-4 rounded-lg bg-first-theme flex flex-wrap mb-4">
                    <div className="text-sm w-6/12 py-2">
                        <div className="text-second-theme mb-2">Seller's {PAYMENT_OFFER_VALUES[orderData.paymentOption].title} Email</div>
                        <div className="">{orderData.emailAddress}</div>
                    </div>
                    <div className="text-sm w-6/12 py-2">
                        <div className="text-second-theme mb-2">{t("Account Name")}</div>
                        <div className="">{orderData.accountName}</div>
                    </div>
                    <div className="text-sm w-6/12 py-2">
                        <div className="text-second-theme mb-2">{t("Reference Message")}</div>
                        <div className="">{orderData.fullId}</div>
                    </div>
                </div>
                <div className="text-sm text-second-theme mb-4">{t("Buyer has marked this payment as “paid”, click on “confirm payment” when you have received the complete fund")}</div>
                <div className="flex mb-8">
                    <GreenButton title={t("Confirm Payment")} cssClass="mr-4 px-8" active onClick={() => setShowConfirmModal(true)} />
                    <GrayButton title={t("Create a Dispute")} onClick={() => setShowDisputeConfirm(true)} />
                </div>
            </div>
            <ConfirmReleaseModal 
                isShown={showConfirmModal} 
                setShown={setShowConfirmModal} 
                handleModal={handlePayment} 
                method={PAYMENT_OFFER_VALUES[orderData.paymentOption].title}
                email={orderData.emailAddress}
                name={orderData.accountName}
                fiatAmount={orderData.fiatAmount}
                id={orderData.fullId}
                isLoading={isLoading} />
            <ReleaseModal
                isShown={showReleaseModal}
                setShown={setShowReleaseModal}
                handleModal={handleRelease}
                fiatAmount={orderData.fiatAmount}
                sellAmount={orderData.sellAmount} />
            <DisputeConfirmModal
                isShown={showDisputeConfirm} 
                setShown={setShowDisputeConfirm} 
                handleModal={handleDisputeConfirm}  />
        </>
    );
}

export default ReleaseContainer;